<template>
  <h2 class="text-3xl font-bold text-center text-indigo-900 mb-12">SchoolMeet.AI</h2>
  <div id="login-screen" class="p-8 rounded-2xl bg-white shadow max-w-sm w-full mx-auto">
    <h2 class="text-2xl font-bold text-black mb-6">Password Reset</h2>
    <div v-if="!isPasswordResetLinkSent">
      <form id="login-form" @submit.prevent="handleLogin">
        <div class="mb-6">
          <label for="email" class="block text-gray-700 font-medium mb-2">Email</label>
          <input v-model="email" type="text"
            class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Email" required />
        </div>
        <button type="submit"
          class="w-full rounded-md bg-indigo-600 px-6 py-3 font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
          <span v-if="!isFetching">Reset Password</span>
          <svg v-if="isFetching" aria-hidden="true" role="status"
            class="inline mr-2 w-4 h-4 text-gray-200 animate-spin dark:text-gray-600" viewBox="0 0 100 101" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"></path>
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="#1C64F2"></path>
          </svg>
        </button>
      </form>
    </div>
    <div v-else>
      <span class="text-green-500 font-bold">
        We have sent a password recover instructions to your email.
      </span>
    </div>

    <div class="text-center pt-8">
      <router-link to="/auth/login">Login</router-link>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import apiClient from '@/axios';
import { toast } from 'vue3-toastify';

export default defineComponent({
  name: 'PasswordReset',
  components: {
  },
  setup() {
    const isFetching = ref<boolean>(false);
    const isPasswordResetLinkSent = ref<boolean>(false);
    const email = ref('');
    const password = ref('');

    const handleLogin = async () => {
      isFetching.value = true;
      try {
        const response = await apiClient.post('/PasswordReset/request', {
          email: email.value,
        });

        if (response.data.success === true) {
          toast.success(response.data.message);
          email.value = '';
          isPasswordResetLinkSent.value = true;
        }
        else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error('Login failed. Please check your credentials.');
      }
      isFetching.value = false;
    };

    return {
      email,
      password,
      isPasswordResetLinkSent,
      handleLogin,
      isFetching
    };
  },
});
</script>

<style scoped>
/* İsteğe bağlı ek stil tanımları */
</style>
